import { CacheTime } from '../cacheTime';
import { handleSubgraphQueryWithFramework } from './subgraphSlice';
export const createCustomQueryEndpoints = (builder) => ({
    custom: builder.query({
        keepUnusedDataFor: CacheTime.None,
        queryFn: (arg) => handleSubgraphQueryWithFramework({
            chainId: arg.chainId,
            handle: (framework) => framework.query.subgraphClient.request(arg.document, arg.variables),
        }),
    }),
});
//# sourceMappingURL=customSubgraphQuery.js.map